export default "__VITE_ASSET__Vpu9HCke__"